module.exports = __webpack_public_path__ + "img/26.764cbd06.jpg";